import React, { Component } from 'react';
import { GraingerAccountContext } from '../Context/Context';

import Page from '../Components/Page/Page'

class Error extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    return (
      <Page title='Page Not Found'>
        <p>
          The page you were looking for was not found
        </p>
      </Page>
    );
  }
}

Error.contextType = GraingerAccountContext;
export default Error;